module.exports = __webpack_public_path__ + "static/type-brigade-50-CommercialClassics16-3a460f607c3c2ff6d3bc247689eba2b2.jpg";